export const REDIRECT_URI_NAME = 'redirect';
